import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  headersProcessosLicitatorios,
  ProcessosLicitatoriosTableRow,
} from './auxiliarProcessosLicitatorios';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import { CustomSwal } from '../../../../components/CustomFeedback/CustomSwal';
import CustomOffcanvas from '../../../../components/CustomOffcanvas';
import CustomRow from '../../../../components/CustomRow';
import DetailsTable from '../../../../components/CustomTable/DetailsTable';
import CustomTableOffcanvas from '../../../../components/CustomTableOffcanvas';
import Select from '../../../../components/InputNew/Select';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useSelect } from '../../../../modules/contexts/Select/useSelect';
import { useNomeCompleto } from '../../../../modules/contexts/userContexts';
import { useKitDeProdutosCache } from '../../../../services/cache/useKitsProdutosCache';
import { getProaqsByUsuario } from '../../../../services/processosAquisitivos/proaqService';
import { getDenominacoesGenericasPorUsuario } from '../../../../services/produtosDAF/denominacoesGenericasService';
import { validarForm } from '../../../../utils/formValidar';
import { formataNomeMeioSiglas, formatDate } from '../../../../utils/functions';
import { valoresExibidosProaq as valoresExibidos } from '../auxiliarProaq';
import { SubAbas } from '../subabas';

const ProaqIndex: React.FC = () => {
  const navigate = useNavigate();
  //DADOS USUARIO
  const user = getUser();
  const userComponenteAFLabel =
    user?.vinculo?.[0]?.nomeInstituicao ?? 'Não informado';
  const userComponenteAF = Number(user.vinculo[0].numeroComponenteAF);
  const { isLoading } = useNomeCompleto();

  // Dados do módulo
  const { getSelectDominioPai } = useSelect();
  const componenteAFoptions = getSelectDominioPai(1);
  const statusProaqOptions = getSelectDominioPai(52);
  const modalidadeAquisicaoOptions = getSelectDominioPai(133);
  const submodalidadePregaoOptions = getSelectDominioPai(139);
  const tipoItemAquisitivoOptions = getSelectDominioPai(142);

  //Denominações Genéricas
  const [denominacaoGenericaData, setDenominacaoGenericaData] = React.useState<
    { id: number; denominacaoGenerica: string }[]
  >([]);

  React.useEffect(() => {
    const fetchDenominacoes = async () => {
      try {
        const data = await getDenominacoesGenericasPorUsuario();
        setDenominacaoGenericaData(data);
      } catch (error) {
        console.error('Erro ao buscar denominações genéricas', error);
      }
    };

    fetchDenominacoes();
  }, []);

  const denominacoesGenericasOptions = React.useMemo(
    () => [
      { value: 0, label: 'Não informado' },
      ...denominacaoGenericaData.map((item) => ({
        value: item.id,
        label: item.denominacaoGenerica,
      })),
    ],
    [denominacaoGenericaData],
  );

  const { data: kitsProdutosData } = useKitDeProdutosCache();
  const kitProdutoOptions = [
    { value: 0, label: 'Não informado' },
    ...kitsProdutosData.map((item) => ({
      value: item.id,
      label: item.nomeKit,
    })),
  ];

  const [showModal, setShowModal] = useState<boolean>(false);

  const [data, setData] = useState<any[]>([]);

  const [formFiltros, setFormFiltros] = useState({
    status: 0,
    componenteAF: 0,
    modAquisicao: 0,
    denominacaoOuKit: '',
  });

  const [formProaqNew, setFormProaqNew] = useState({
    denominacaoGenericaId: 0,
    fluxoProaqId: 0,
    kitProdutosDAFId: 0,
    componenteAF: 0,
    modalidadeAquisicao: 0,
    subtipoModalidade: 0,
    tipoItemAquisitivo: 0,
  });

  const tituloModal = 'Novo Registro';

  // Buscar dados
  const fetchDataMain = async () => {
    try {
      const proaqData = await getProaqsByUsuario();

      setData(proaqData);
    } catch (error) {}
  };

  useEffect(() => {
    fetchDataMain();
  }, [isLoading]);

  //Dados da tabela
  const tableData = data.map((item) => ({
    id: item?.id ?? 'Não informado',

    status:
      statusProaqOptions.find((status) => status.value === item.status)
        ?.label ?? 'Não informado',
    componenteAf:
      componenteAFoptions.find(
        (componenteAf) => componenteAf.value === item.componenteAF,
      )?.label ?? 'Não informado',
    modalidade:
      modalidadeAquisicaoOptions.find(
        (modalidade) => modalidade.value === item.modalidade,
      )?.label ?? 'Não informado',
    submodalidade:
      submodalidadePregaoOptions.find(
        (submodalidade) => submodalidade.value === item.submodalidade,
      )?.label ?? 'Não informado',
    denominacaoKit:
      item?.denominacaoGenerica.denominacaoGenerica ??
      item?.KitProdutoDAF?.nomeKit ??
      'Não informado',
    denominacaoKitBool: item?.denominacaoGenerica ? 'D' : 'K',
  }));

  const offCanvasData = data.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    separadorLog: '',
    denominacaoGenerica: <b>{item.denominacaoGenerica?.denominacaoGenerica}</b>,

    // separadorObservacoes: '',
    observacoes: item.observacoes,
  }));

  // Funções Handle
  const handleShowModal = () => {
    setFormProaqNew((prev) => ({
      ...prev,
      componenteAF: userComponenteAF,
      denominacaoGenericaId: 0,
      fluxoProaqId: 0,
      kitProdutosDAFId: 0,
      modalidadeAquisicao: 0,
      tipoItemAquisitivo: 0,
    }));
    setShowModal((show) => !show);
  };

  const handleInserir = () => {
    handleShowModal();
  };

  const handleClickModalInserir = () => {
    if (
      ['Gabinete', 'Coordenação de Fiscalização de Contratos'].includes(
        userComponenteAFLabel,
      )
    ) {
      CustomSwal.show({
        type: 'warning',
        title: 'Atenção',
        html: 'Usuários vinculados ao Gabinete ou à Coordenação de Fiscalização de Contratos não podem criar Processos Licitatórios.',
        showConfirmButton: true,
      });
      return;
    }
    setFormProaqNew((prev) => ({
      ...prev,
      componenteAF: userComponenteAF,
    }));

    const camposObrigatorios: Record<string, string> = {
      componenteAF: 'Componente AF',
      modalidadeAquisicao: 'Modalidade Aquisição',
      subtipoModalidade: 'Subtipo Modalidade',
      tipoItemAquisitivo: 'Tipo Item Aquisitivo',
    };
    if (formProaqNew.tipoItemAquisitivo === 143) {
      camposObrigatorios.denominacaoGenericaId = 'Denominação Genérica';
    } else {
      camposObrigatorios.kitProdutosDAFId = 'Kit de Produtos DAF';
    }

    const formValidado = validarForm(formProaqNew, camposObrigatorios);
    if (formValidado) {
      navigate('dadosgerais', { state: { formProaqNew } });
    }
  };

  const handleChangeModal = (e: any) => {
    const { name, value } = e.target;
    const newValue = parseInt(value, 10);
    setFormProaqNew((prev) => ({ ...prev, [name]: newValue }));

    if (name === 'modalidadeAquisicao') {
      setFormProaqNew((prev) => ({ ...prev, subtipoModalidade: 0 }));
    }
  };

  const [selectedDetailsRowId, setSelectedDetailsRowId] = useState<
    string | number | null
  >(null);
  const offcanvasOpenRoute = useMemo(() => {
    if (!selectedDetailsRowId) return undefined;

    const baseHash = window.location.hash.replace(/\/$/, '');
    return `${baseHash}/${selectedDetailsRowId}/dadosgerais`;
  }, [selectedDetailsRowId]);

  const handleOpenDetails = (row: ProcessosLicitatoriosTableRow) => {
    if (!row?.id) return;
    setSelectedDetailsRowId(row.id);
  };

  const handleTableRowClick = (row: ProcessosLicitatoriosTableRow) => {
    if (row?.id) {
      navigate(`${row.id}/dadosgerais`);
    }
  };

  return (
    <>
      <BarraSubAbas subAbas={SubAbas} />

      <ContainerConteudo>
        <CustomTableOffcanvas
          headers={headersProcessosLicitatorios}
          data={tableData}
          displayValues={valoresExibidos}
          offcanvasTitle="Processos Licitatórios - Detalhes"
          widthOffcanvas="50%"
          openRoute={offcanvasOpenRoute}
          onOpenOffcanvas={handleOpenDetails}
          onRowClick={handleTableRowClick}
          itemsPerPage={50}
          // emptyMessage="Carregando..."
          showPagination={true}
          showOpenButton={true}
          filterable={true}
        >
          {(row) => (
            <DetailsTable
              rows={offCanvasData}
              selectedId={row?.id ?? selectedDetailsRowId}
              displayValues={valoresExibidos}
            />
          )}
        </CustomTableOffcanvas>
      </ContainerConteudo>

      <CustomOffcanvas
        // icone={iconeModal}
        title={tituloModal}
        show={showModal}
        onClose={handleShowModal}
        width="60vw"
        footerContent={
          <BarraInferiorBotoes>
            <WorkspaceBotoes inserir onClickInserir={handleClickModalInserir} />
          </BarraInferiorBotoes>
        }
      >
        <WorkspaceFicha>
          <BoxConteudo boxTitulo="Dados do Processo Aquisitivo">
            <CustomRow style={{ marginTop: '-10px' }}>
              <CustomCol width="200px">
                <Select
                  name="componenteAF"
                  value={userComponenteAF}
                  options={componenteAFoptions}
                  onChange={handleChangeModal}
                  label="Componente AF"
                  required
                  disabled
                />
              </CustomCol>
              <CustomCol width="220px">
                <Select
                  name="modalidadeAquisicao"
                  value={formProaqNew.modalidadeAquisicao}
                  options={modalidadeAquisicaoOptions}
                  onChange={handleChangeModal}
                  label="Modalidade de Aquisição"
                  required
                />
              </CustomCol>

              <CustomCol width="200px">
                <Select
                  name="subtipoModalidade"
                  value={formProaqNew.subtipoModalidade}
                  // options={
                  //   Number(formProaqNew.modalidadeAquisicao) === 134
                  //     ? submodalidadeDispensaOptions
                  //     : submodalidadePregaoOptions
                  // }
                  options={submodalidadePregaoOptions}
                  onChange={handleChangeModal}
                  label="Subtipo Mododalidade"
                  required
                />
              </CustomCol>

              <CustomCol width="300px">
                <Select
                  name="tipoItemAquisitivo"
                  value={formProaqNew.tipoItemAquisitivo}
                  options={tipoItemAquisitivoOptions}
                  onChange={handleChangeModal}
                  label="Tipo de Item do Processo"
                  required
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>
            <CustomRow style={{ marginTop: '10px' }}>
              {formProaqNew.tipoItemAquisitivo &&
              formProaqNew.tipoItemAquisitivo === 144 ? (
                <CustomCol width="100%">
                  <Select
                    name="kitProdutosDAFId"
                    value={formProaqNew.kitProdutosDAFId}
                    options={kitProdutoOptions}
                    onChange={handleChangeModal}
                    label="Kit de Produtos"
                    required
                  />
                </CustomCol>
              ) : (
                <CustomCol width="100%">
                  <Select
                    name="denominacaoGenericaId"
                    value={formProaqNew.denominacaoGenericaId}
                    options={denominacoesGenericasOptions}
                    onChange={handleChangeModal}
                    label="Denominação Genérica"
                    required
                  />
                </CustomCol>
              )}
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </CustomOffcanvas>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          // download
          // downloadDisabled={isExporting || !(tableData.length > 0)}
          // onClickDownload={handleExport}
          inserir
          onClickInserir={handleInserir}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default ProaqIndex;
